import { ParentContext } from 'global/cnr/contexts/ParentContext';
import { openExternal } from 'global/viewSettings/helpers/settingsLinks';
import FullPageWrapper from 'global/wrappers/FullPageWrapper';
import ItemMenuSquares, { _imsTypes } from 'global/wrappers/ItemMenuSquares';
import Wrapper, { wrapperTypes } from 'global/wrappers/Wrapper';
import { useContext, useEffect, useState } from 'react';
import { Button, Icon, Label } from 'semantic-ui-react';
import { _sportCollections } from '../cnr/reducers/SportsSidebarReducer';
import { _allowSportsUpdates } from '../useHelpers/useSeasonals';
import { useTeamRosters } from '../useHelpers/useTeamRosters';
import { _seasonPasteTypes, SeasonPaste } from './SeasonPaste';

export default function RosterBuilder({ currentTeam, roster, handleCancel }) {

  const { _itemKey: team_key } = currentTeam ?? {}

  const parentContext = useContext(ParentContext);
  const { states, fns } = parentContext ?? {}
  const { paps_state } = states ?? {}
  const { pathViews } = paps_state ?? {}
  const teamKey = team_key || pathViews?.teams

  const { updateRoster, getTeamRosters, updating } = useTeamRosters()

  const [currentTeamRosters, setCurrentTeamRosters] = useState({
    combinedRosters: {},
  })

  const handleNewRoster = (newRoster) => {
    setCurrentTeamRosters(prev => {
      const next = _.cloneDeep(prev);
      const combined = next.combinedRosters ?? {};

      console.log('combined', combined)

      next.combinedRosters = _.mergeWith(
        {},
        combined,
        newRoster,
        (objValue, srcValue) => {
          if (_.isArray(objValue)) {
            return _.uniq([...objValue, ...srcValue]);
          }
        }
      );
      return next;
    });

  };

  useEffect(() => {

    const cb_teamRosters = ({ parentKey, teamRosters, fullRosters }) => {
      setCurrentTeamRosters(prev => {
        const combinedRosters = _.cloneDeep(fullRosters);
        const _combinedRosters = combinedRosters?.[teamKey]
        console.log('_combinedRosters', _combinedRosters)
        return {
          ...prev,
          combinedRosters: _combinedRosters,
        };
      });
    };

    if (roster) {
      setCurrentTeamRosters({
        combinedRosters: roster
      })
    } else {
      getTeamRosters({ callback: cb_teamRosters })
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [roster]);

  const externals = {
    seasonMatches: () => openExternal.firebaseDbDirect(pathViews, [_sportCollections._rosters]),
  }

  const handleUpdate_matches = () => {
    updateRoster({ teamKey, roster: currentTeamRosters.combinedRosters })
  }

  const footer = () => <div style={{ display: 'flex', justifyContent: 'space-between' }}>
    <div>
      <Button
        labelPosition='right'
        content={`Open Rosters`}
        size='mini'
        color={'orange'}
        icon='external alternate'
        onClick={() => { externals.seasonMatches() }} />
    </div>
    <div>
      <Button
        labelPosition='right'
        content={`Update Roster`}
        size='mini'
        color={_.isEmpty(currentTeamRosters?.combinedRosters) ? 'grey' : _allowSportsUpdates.matches ? 'green' : 'teal'}
        icon='save'
        disabled={_.isEmpty(currentTeamRosters?.combinedRosters)}
        onClick={() => { handleUpdate_matches() }} />
    </div>
  </div>

  const lbl_icn = (icon, value, width) => <Label size='mini' style={{ flex: 1, width: width ? `${width}px` : '40px', textAlign: 'center' }}>
    <Icon name={icon} color={'blue'} />{value}
  </Label>

  const fnAlt_roster_combined = (item) => {
    const { seasons, graduationYear } = item ?? {}
    const sportsYears = _.keys(seasons)
    return <div style={{ display: 'flex', columnGap: '.5em', width: '240px', justifyContent: 'space-between' }}>
      {lbl_icn('calendar alternate outline', sportsYears && sportsYears.join(', '), 80)}
      {lbl_icn('calendar outline', graduationYear, 60)}
    </div>
  }

  const wrapper = () => {
    let _roster = currentTeamRosters?.combinedRosters
    return <Wrapper
      header={<SeasonPaste roster={_roster} handle_paste={handleNewRoster} seasonPasteType={_seasonPasteTypes.roster} />}
      content={<ItemMenuSquares
        menuItems={_roster}
        imsType={_imsTypes.inline}
        fn_altContent={fnAlt_roster_combined}
      />}
      footer={footer()}
      wrapperType={wrapperTypes.padded}
    ></Wrapper>
  }

  if (handleCancel) {
    return <FullPageWrapper
      topperCaption={'Team Roster'}
      content={wrapper()}
      handleCancel={handleCancel}
      css={{ container: 'app-dark-mode' }}
    ></FullPageWrapper>
  } else {
    return wrapper()
  }
}